import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import TableBody from "../Table/TableBody";
import TableHeader from "../Table/TableHeader";
import { useLanguage } from "../LangTranslation/LanguageContext";
import { useSession } from "../../authentications/SessionContext";
import { SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT } from "../../utilities/constants";
import Modal from "../Kanban/Modal/Modal";
import DeliveryInfoDetail from "./DeliveryInfoDetail";
import { read } from "../../DataApi/read";
import { callButtonGeneral } from "../../DataApi/generalApis/callButtonGeneral";
import { handleResponse } from "../../utilities/handleResponse";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";

const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 13px;
  min-height: 200px !important;
`;

function DeliveryInfo({
  selectedOrder,
  selectedSaleOrderDetail,
  deliveryOrders,
  setDeliveryOrders,
  fetchData,
}) {
  const { sessionInfo } = useSession();
  const { company_id, context } = sessionInfo;

  const [selectedDeliveryOrder, setSelectedDeliveryOrder] = useState(false);
  const { language, translations } = useLanguage();
  const [isLoadingData, setIsLoadingData] = useState(true);
  const t = translations[language];
  const { ConfirmationModal, setTitle, setMetaData, setOpenModal } =
    useConfirmationModal();
  const getDeliveryList = async (orderDetail = selectedSaleOrderDetail) => {
    try {
      const model = "stock.picking";
      const fields = [
        "priority",
        "name",
        "location_id",
        "location_dest_id",
        "partner_id",
        "signature",
        "user_id",
        "scheduled_date",
        "date_deadline",
        "origin",
        "group_id",
        "backorder_id",
        "carrier_tracking_ref",
        "carrier_id",
        "weight",
        "shipping_weight",
        "picking_type_id",
        "company_id",
        "state",
        "activity_exception_decoration",
        "activity_exception_icon",
        "json_popover",
        "delivery_type",
      ];

      let readResponse = await read({
        change: fields,
        company_id,
        context,
        id: orderDetail.picking_ids,
        model,
      });
      readResponse = JSON.parse(readResponse);
      setDeliveryOrders(readResponse?.result || []);

      setIsLoadingData(false);
      return readResponse?.result || [];
    } catch (error) {
      setIsLoadingData(false);
    }
  };
  const handleConfirmDelivery = async () => {
    setIsLoadingData(true);
    const orderDetail = await fetchData();
    getDeliveryList(orderDetail);
  };

  const handleCloseDeliveryInfoDetailModal = () => {
    setSelectedDeliveryOrder(false);
  };
  const handlePrintLabel = async ({ item, data, index }) => {
    // console.log("item,data,index", item, data, index);
    const response = await callButtonGeneral({
      company_id,
      method: "rpc_action_get_package_label",
      model: "stock.picking",
      args: [data.id],
      context,
    });
    // console.log("response of print button", response);
    if (response?.result?.url) {
      var newPage = window.open(response?.result?.url, "_blank");
      if (newPage) {
        newPage.focus();
      }
    } else {
      setOpenModal(true);
      handleResponse({
        response: response,
        setMetaData,
        setTitle,
      });
    }
  };

  useEffect(() => {
    if (deliveryOrders?.length === 0) setIsLoadingData(true);
    getDeliveryList();
  }, []);
  const renderInputList = useMemo(
    () => [
      {
        title: "Refrence",
        name: "name",
      },
      {
        title: "From",
        name: "location_id",
        handleCell: (data, item) => data?.[item.name]?.[1] || "",
      },
      {
        title: "To",
        name: "location_dest_id",
        handleCell: (data, item) => data?.[item.name]?.[1] || "",
      },
      {
        title: "Schedule Date",
        name: "scheduled_date",
        dateFormat: SCHEDULE_ACTIVITY_INPUT_DATE_FORMAT,
      },
      {
        title: "Source Document",
        name: "origin",
      },
      {
        title: "Status",
        name: "state",
        customRender: ({ item, data, index }) => (
          <span>
            {data?.[item.name] === "assigned"
              ? "To Confirm"
              : data?.[item.name]}
          </span>
        ),
      },
      {
        title: "",
        customRender: ({ item, data, index }) => (
          <button
            title="Print Label"
            className={`btn btn-outline-danger rounded ${
              data.delivery_type !== "asyad" || data.state !== "done"
                ? "d-none"
                : "d-block"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              handlePrintLabel({ item, data, index });
            }}
          >
            <i className="bi bi-printer-fill mx-2"></i>
          </button>
        ),
      },
    ],
    []
  );
  return (
    <>
      <Modal
        onClose={handleCloseDeliveryInfoDetailModal}
        isOpen={Boolean(selectedDeliveryOrder)}
      >
        <DeliveryInfoDetail
          handleGetDeliveryOrders={handleConfirmDelivery}
          selectedDeliveryOrder={selectedDeliveryOrder}
          handleCloseDeliveryInfoDetailModal={
            handleCloseDeliveryInfoDetailModal
          }
        />
      </Modal>
      <TableContainer>
        <ConfirmationModal />
        <table className="table">
          <TableHeader tableHeaderList={renderInputList} />

          <TableBody
            tableData={deliveryOrders}
            tableBodyList={renderInputList}
            handleRowClick={(data) => {
              setSelectedDeliveryOrder(data.id);
            }}
            isLoadingData={isLoadingData}
            checkIsLoadingData
          />
        </table>
      </TableContainer>
    </>
  );
}

export default DeliveryInfo;
